import { Component } from '@angular/core';

@Component({
  selector: 'ui-flex',
  templateUrl: './flex.component.html'
})
export class FlexComponent {
}